import { userApis } from '@apis/userApis';
import { useMutation } from '@hooks/useMutation';
import { AuthManager } from '@store/AuthManager';
import { useQueryClient } from '@tanstack/react-query';

export const useLogout = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      try {
        AuthManager.shared.setIsLoggingOut(true);
        const response = await userApis.post('/logout/', {});
        AuthManager.shared.clear();
        return response[200]!;
      } finally {
        AuthManager.shared.setIsLoggingOut(false);
      }
    },
    {
      onSuccess: () => {
        queryClient.removeQueries();
      },
    },
  );
};
